module.exports = "/cyber/_next/static/images/pointer-702f5a741aee7b1585b3eece49336b7b.png";